/*
 * <<
 * Davinci
 * ==
 * Copyright (C) 2016 - 2017 EDP
 * ==
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * >>
 */

import React, {ChangeEvent, FormEvent, useState} from 'react'

import '../BasLogin/Login.css'
import BasWechatBindForm from "../../components/WechatBindForm/BasWechatBindForm";

export const BasWechatBind: React.FC = () => {
    const [wechatCode, setWechatCode] = useState(false);
    return (
        <>
            <div className={'login-window'}>
                <div className={'login-mock'}>
                    <BasWechatBindForm />
                </div>
            </div>
        </>
    )
}
export default BasWechatBind;
